import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx } from "react/jsx-runtime";
//#region src/components/BookFill.tsx
const BookFillIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M11 4.513A11.818 11.818 0 0 0 7.5 4c-1.526 0-2.755.271-3.612.548a8.889 8.889 0 0 0-1.001.389 5.905 5.905 0 0 0-.357.18l-.025.014-.009.005-.003.002h-.001M11 4.513v15.12a7.523 7.523 0 0 0-.503-.181A9.77 9.77 0 0 0 7.5 19a9.77 9.77 0 0 0-2.997.451 6.896 6.896 0 0 0-.775.3 3.974 3.974 0 0 0-.219.11A1 1 0 0 1 2 19V6a1 1 0 0 1 .489-.86l-.108.064.11-.064M13 19.634c.14-.057.308-.12.503-.183A9.77 9.77 0 0 1 16.5 19a9.77 9.77 0 0 1 2.997.451 6.9 6.9 0 0 1 .775.3 3.976 3.976 0 0 1 .219.11l.003.002-.002-.002A1 1 0 0 0 22 19V6a1 1 0 0 0-.49-.86l-.002-.001h-.001l-.003-.003-.01-.005-.024-.014a5.883 5.883 0 0 0-.357-.18 8.897 8.897 0 0 0-1-.389A11.769 11.769 0 0 0 16.5 4c-1.46 0-2.649.249-3.5.513v15.12Z",
		fill: props.fill || "currentColor"
	})
}));
//#endregion
export { BookFillIcon };
